import { PricedVariant } from '@medusajs/medusa/dist/types/pricing';

import { useTranslation } from '@/app/i18n/client';
import { Locale } from '@/app/i18n/locale';

import styles from './styles.module.scss';

interface VariantsProps {
  variants: PricedVariant[];
  selectVariant: (variant: PricedVariant) => void;
  selectedVariant: PricedVariant | undefined;
  checkVariantAvailability: (id: string) => boolean;
  lng: Locale;
}

export const Variants = ({
  variants,
  selectVariant,
  selectedVariant,
  checkVariantAvailability,
  lng,
}: VariantsProps) => {
  const { t } = useTranslation(lng, ['product']);
  return (
    <div>
      <h5 className={styles.heading}>{t('selectVariant')}</h5>
      <div className={styles.selectVariant}>
        {variants.map(variant => {
          if (variant.material === 'value') {
            return (
              <div key={variant.id} className={styles.content}>
                <button
                  key={variant.id}
                  onClick={() => selectVariant(variant)}
                  className={[
                    styles.valueBtn,
                    selectedVariant &&
                      variant.id === selectedVariant.id &&
                      styles.checked,
                    ,
                    variant.id &&
                      !checkVariantAvailability(variant.id) &&
                      styles.outOfStock,
                  ].join(' ')}
                >
                  {variant.options && variant.options[0].value}
                </button>
                <p
                  className={
                    selectedVariant && variant.id === selectedVariant.id
                      ? styles.pChecked
                      : ''
                  }
                >
                  {lng === 'pl'
                    ? variant.title
                    : (variant.metadata?.english_title as string) ||
                      variant.title}
                </p>
              </div>
            );
          } else {
            const color = variant.material;
            const splitted = color?.split('/');

            let backgroundColor = '#ddd';
            if (splitted?.length === 1) {
              backgroundColor = splitted[0];
            } else if (splitted?.length === 2) {
              backgroundColor = `linear-gradient(to right, ${splitted[0]} 0%, ${splitted[0]} 50%, ${splitted[1]} 50%, ${splitted[1]} 100%)`;
            }

            return (
              <div key={variant.id} className={styles.content}>
                <div
                  className={[
                    styles.btnWrapper,
                    selectedVariant &&
                      variant.id === selectedVariant.id &&
                      styles.checked,
                  ].join(' ')}
                >
                  <button
                    onClick={() => selectVariant(variant)}
                    className={[
                      styles.colorSwatch,
                      variant.id &&
                        !checkVariantAvailability(variant.id) &&
                        styles.outOfStock,
                    ].join(' ')}
                    style={{
                      background: backgroundColor,
                    }}
                  />
                </div>
                <p
                  className={
                    selectedVariant && variant.id === selectedVariant.id
                      ? styles.pChecked
                      : ''
                  }
                >
                  {lng === 'pl'
                    ? variant.title
                    : (variant.metadata?.english_title as string) ||
                      variant.title}
                </p>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};
